<div class="dialog-container" [formGroup]="form">

  <h2 mat-dialog-title>{{ form.get('testDefinitionId').value ? 'Edit' : 'New' }} Rule Definition</h2>

  <!-- Tab bar -->
  <div class="tab-bar" style="display:flex; gap:8px; margin-bottom:16px;">
    <button pButton pRipple [class]="activeTab==='guided' ? 'p-button' : 'p-button-outlined'"
      label="Guided" icon="pi pi-cog" (click)="setTab('guided')"></button>
    <button pButton pRipple [class]="activeTab==='ai' ? 'p-button' : 'p-button-outlined'"
      label="AI Interpret" icon="pi pi-bolt" (click)="setTab('ai')"></button>
  </div>

  <mat-dialog-content style="min-height:420px;">

    <!-- ─────────── GUIDED TAB ─────────── -->
    @if (activeTab === 'guided') {
      <div class="p-fluid p-formgrid p-grid">

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Test Name *</label>
          <input pInputText formControlName="testName" />
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Display Name</label>
          <input pInputText formControlName="testDisplayName" />
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Category</label>
          <p-dropdown formControlName="testCategory" [options]="categoryOptions"
            optionLabel="label" optionValue="value" placeholder="Select category"
            appendTo="body" [showClear]="true"></p-dropdown>
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Severity *</label>
          <p-dropdown formControlName="severity" [options]="severityOptions"
            optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Rule Type</label>
          <p-dropdown formControlName="ruleType" [options]="ruleTypeOptions"
            optionLabel="label" optionValue="value" appendTo="body"
            [showClear]="true" placeholder="Select rule type"></p-dropdown>
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Rule Field</label>
          <p-dropdown formControlName="ruleField" [options]="fieldOptions"
            optionLabel="label" optionValue="value" appendTo="body"
            [showClear]="true" placeholder="Select field"
            [filter]="true" filterBy="label"></p-dropdown>
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Operator</label>
          <p-dropdown formControlName="ruleOperator" [options]="operatorOptions"
            optionLabel="label" optionValue="value" appendTo="body"
            [showClear]="true" placeholder="Select operator"></p-dropdown>
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Threshold</label>
          <input pInputText formControlName="ruleThreshold" placeholder="e.g. 5, true, some-value" />
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Score Weight</label>
          <p-inputNumber formControlName="scoreWeight" [min]="0" [max]="100"></p-inputNumber>
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Sort Order</label>
          <p-inputNumber formControlName="sortOrder" [min]="0"></p-inputNumber>
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Applies To Island</label>
          <input pInputText formControlName="appliesToIsland" placeholder="All, Maui, Oahu..." />
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>Applies To Channel</label>
          <input pInputText formControlName="appliesToChannel" placeholder="All, VRBO, Airbnb..." />
        </div>

        <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
          <label>AI Eval Model</label>
          <input pInputText formControlName="aiEvalModel" placeholder="e.g. claude-3-haiku" />
        </div>

        <div class="p-field p-col-12" style="margin-bottom:12px;">
          <label>AI Eval Prompt</label>
          <textarea pInputTextarea formControlName="aiEvalPrompt" rows="3"
            placeholder="Prompt for AI evaluation (if ruleType=AI_EVAL)"></textarea>
        </div>

        <div class="p-field p-col-12" style="margin-bottom:12px;">
          <label>Expectation Description</label>
          <textarea pInputTextarea formControlName="testExpectationDesc" rows="2"
            placeholder="What does this test expect?"></textarea>
        </div>

        <div class="p-field p-col-12" style="margin-bottom:12px;">
          <label>Notes</label>
          <textarea pInputTextarea formControlName="notes" rows="2"></textarea>
        </div>

        <div class="p-field p-col-12" style="margin-bottom:12px; display:flex; align-items:center; gap:8px;">
          <p-checkbox formControlName="isActive" [binary]="true" [trueValue]="1" [falseValue]="0"
            inputId="isActive"></p-checkbox>
          <label for="isActive" style="margin:0;">Active</label>
        </div>

      </div>
    }

    <!-- ─────────── AI INTERPRET TAB ─────────── -->
    @if (activeTab === 'ai') {
      <div>
        <p style="color:#555; margin-bottom:8px;">
          Describe a quality rule in plain English. The AI will interpret it into structured fields.
        </p>
        <div style="margin-bottom:12px;">
          <label>Rule Description</label>
          <textarea pInputTextarea [(ngModel)]="interpretText" [ngModelOptions]="{standalone:true}" rows="4"
            placeholder="e.g. The listing must have at least 5 photos. Severity: FAIL."></textarea>
        </div>

        <button pButton pRipple label="Interpret" icon="pi pi-bolt"
          [loading]="interpreting"
          [disabled]="!interpretText.trim() || interpreting"
          (click)="onInterpret()"
          style="margin-bottom:16px;"></button>

        @if (interpretResult) {
          <div class="interpret-result-card"
            style="border:1px solid #ddd; border-radius:6px; padding:16px; background:#fafafa;">
            <div style="display:flex; align-items:center; gap:12px; margin-bottom:12px;">
              <p-tag [value]="interpretResult.resolution"
                [severity]="getResolutionSeverity(interpretResult.resolution)"></p-tag>
              <span style="font-size:0.85rem; color:#666;">
                Confidence: <strong>{{interpretResult.confidence}}</strong>
              </span>
            </div>
            <div style="display:grid; grid-template-columns:1fr 1fr; gap:8px; font-size:0.9rem; margin-bottom:12px;">
              <div><strong>Rule Type:</strong> {{interpretResult.ruleType || '—'}}</div>
              <div><strong>Rule Field:</strong> {{interpretResult.ruleField || '—'}}</div>
              <div><strong>Operator:</strong> {{interpretResult.ruleOperator || '—'}}</div>
              <div><strong>Threshold:</strong> {{interpretResult.ruleThreshold || '—'}}</div>
            </div>
            @if (interpretResult.aiEvalPrompt) {
              <div style="margin-bottom:8px; font-size:0.9rem;">
                <strong>AI Prompt:</strong> {{interpretResult.aiEvalPrompt}}
              </div>
            }
            @if (interpretResult.rationale) {
              <div style="font-size:0.85rem; color:#555; border-top:1px solid #eee; padding-top:8px;">
                <strong>Rationale:</strong> {{interpretResult.rationale}}
              </div>
            }
            <div style="margin-top:12px;">
              <button pButton pRipple label="Apply to Form" icon="pi pi-check"
                class="p-button-success p-button-sm" (click)="applyResult()"></button>
            </div>
          </div>
        }
      </div>
    }

  </mat-dialog-content>

  <mat-dialog-actions align="end" style="gap:8px; padding:16px;">
    @if (formLoading) {
      <app-spinner [formLoading]="formLoading"></app-spinner>
    }
    <button pButton pRipple label="Cancel" class="p-button-outlined"
      (click)="onCancel()" [disabled]="formLoading"></button>
    <button pButton pRipple label="Save" icon="pi pi-save"
      (click)="onSave()" [disabled]="formLoading || form.invalid"></button>
  </mat-dialog-actions>

</div>
